export default __webpack_public_path__ + "static/media/pendingNotification.32c1de00.svg";